// Import individual editorial files
import californiaAdobeLegacy from '../../content/editorials/california-adobe-legacy.js';
import tizioLampEditorial from '../../content/editorials/tizio-lamp-editorial.js';
import akariLightEditorial from '../../content/editorials/akari-light-editorial.js';
import sonosOneEditorial from '../../content/editorials/sonos-one-editorial.js';
import tuttleAmanjenaEditorial from '../../content/editorials/tuttle-amanjena-editorial.js';
import defenderEditorial from '../../content/editorials/defender-editorial.js';
import riseBeyondTheReefEditorial from '../../content/editorials/rise-beyond-the-reef-editorial.js';

// Combine all editorials
const editorials = [
 californiaAdobeLegacy, // New adobe editorial
 riseBeyondTheReefEditorial, // Rise Beyond the Reef editorial
 tuttleAmanjenaEditorial, // Ed Tuttle Amanjena editorial
 defenderEditorial, // Land Rover Defender editorial
 tizioLampEditorial,    // Existing editorials moved to separate files
 akariLightEditorial,
 sonosOneEditorial
];

export default editorials;